/**
 * SEC-418: the TCP server logs the result of an on-screen message on the receiving
 * device as "<result>: <message text>", for example
 * "Skärmmeddelande levererat via SMS: Larm: Anna"
 * (securcloud-tcp-server utils/osm-delivery.js). The result is translated with the
 * securtool_log_message keys; the message text is shown as it was sent.
 */
const OSM_RESULTS = [
  "Skärmmeddelande levererat",
  "Skärmmeddelande levererat (SMS skickades också)",
  "Skärmmeddelande levererat via SMS",
  "Skärmmeddelande EJ levererat (inget telefonnummer för SMS)",
  "Skärmmeddelande EJ levererat (SMS kunde inte skickas)",
  "Skärmmeddelande EJ levererat (inget svar via TCP eller SMS)",
  "Skärmmeddelandet nekades av enheten",
];

/** The translated row text, or null when the row is not an on-screen message result. */
export function translateOsmLogReport(logReport, t) {
  if (!logReport) return null;

  for (const result of OSM_RESULTS) {
    const prefix = `${result}: `;

    if (logReport.startsWith(prefix)) {
      const messageText = logReport.slice(prefix.length);
      return `${t(`securtool_log_message.${result}`)}: ${messageText}`;
    }
  }

  return null;
}
